// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .empty-pdp-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;
    margin-left: auto;
    margin-top: 120px;
    margin-right: auto;
  }
  .subtext {
    font-size: 18px;
  }
  .header {
    font-size: 28px;
  }
  .back-cta {
    border-radius: 6px;
    width: 60%;
    text-transform: capitalize;
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .empty-pdp-container {
      width: 90%;
    }
    .back-cta {
      width: 95%;
    }
    .header {
      font-size: 16px;
    }
    .subtext {
      font-size: 14px;
    }
  }
`;

export default styles;
